var _g, _rect, _path, _path2, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _path3, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContentEffectivenessIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 485,
    height: 283,
    viewBox: "0 0 485 283",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#pj7ydgepma)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.934,
    y: 8.462,
    width: 459.508,
    height: 258.42,
    rx: 16,
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.934,
    y: 11.462,
    width: 453.508,
    height: 252.42,
    rx: 13,
    stroke: "#fff",
    strokeWidth: 6
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 49.376,
    y: 32.569,
    width: 376.896,
    height: 210.207,
    rx: 8,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#BCE8F9",
    d: "M68.44 110.025h338.768v17.221H68.44zM68.44 141.711h338.768v17.221H68.44zM68.44 173.397h338.768v17.221H68.44zM68.44 205.083h338.768v17.221H68.44z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#BEBEBE",
    d: "M68.44 71.451h338.768v21.354H68.44z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 78.775,
    y: 79.717,
    width: 45.935,
    height: 2.755,
    rx: 1.378,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 175.237,
    y: 79.717,
    width: 30.432,
    height: 2.755,
    rx: 1.378,
    fill: "#fff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 78.775,
    y: 116.914,
    width: 30.432,
    height: 2.755,
    rx: 1.378,
    fill: "#909090"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 184.425,
    y: 116.914,
    width: 12.058,
    height: 2.755,
    rx: 1.378,
    fill: "#909090"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 231.509,
    y: 116.914,
    width: 12.058,
    height: 2.755,
    rx: 1.378,
    fill: "#909090"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 278.592,
    y: 116.914,
    width: 12.058,
    height: 2.755,
    rx: 1.378,
    fill: "#909090"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 325.674,
    y: 116.914,
    width: 12.058,
    height: 2.755,
    rx: 1.378,
    fill: "#909090"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 372.758,
    y: 116.914,
    width: 12.058,
    height: 2.755,
    rx: 1.378,
    fill: "#909090"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 78.775,
    y: 148.6,
    width: 30.432,
    height: 2.755,
    rx: 1.378,
    fill: "#909090"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 184.425,
    y: 148.6,
    width: 12.058,
    height: 2.755,
    rx: 1.378,
    fill: "#909090"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 231.509,
    y: 148.6,
    width: 12.058,
    height: 2.755,
    rx: 1.378,
    fill: "#909090"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 278.592,
    y: 148.6,
    width: 12.058,
    height: 2.755,
    rx: 1.378,
    fill: "#909090"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 325.674,
    y: 148.6,
    width: 12.058,
    height: 2.755,
    rx: 1.378,
    fill: "#909090"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 372.758,
    y: 148.6,
    width: 12.058,
    height: 2.755,
    rx: 1.378,
    fill: "#909090"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 78.775,
    y: 180.286,
    width: 30.432,
    height: 2.755,
    rx: 1.378,
    fill: "#909090"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 184.425,
    y: 180.286,
    width: 12.058,
    height: 2.755,
    rx: 1.378,
    fill: "#909090"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 231.509,
    y: 180.286,
    width: 12.058,
    height: 2.755,
    rx: 1.378,
    fill: "#909090"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 278.592,
    y: 180.286,
    width: 12.058,
    height: 2.755,
    rx: 1.378,
    fill: "#909090"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 325.674,
    y: 180.286,
    width: 12.058,
    height: 2.755,
    rx: 1.378,
    fill: "#909090"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 372.758,
    y: 180.286,
    width: 12.058,
    height: 2.755,
    rx: 1.378,
    fill: "#909090"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 78.775,
    y: 211.972,
    width: 30.432,
    height: 2.755,
    rx: 1.378,
    fill: "#909090"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 184.425,
    y: 211.972,
    width: 12.058,
    height: 2.755,
    rx: 1.378,
    fill: "#909090"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 231.509,
    y: 211.972,
    width: 12.058,
    height: 2.755,
    rx: 1.378,
    fill: "#909090"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 278.592,
    y: 211.972,
    width: 12.058,
    height: 2.755,
    rx: 1.378,
    fill: "#909090"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 325.674,
    y: 211.972,
    width: 12.058,
    height: 2.755,
    rx: 1.378,
    fill: "#909090"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 372.758,
    y: 211.972,
    width: 12.058,
    height: 2.755,
    rx: 1.378,
    fill: "#909090"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 222.32,
    y: 79.717,
    width: 30.432,
    height: 2.755,
    rx: 1.378,
    fill: "#fff"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 269.405,
    y: 79.717,
    width: 30.432,
    height: 2.755,
    rx: 1.378,
    fill: "#fff"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 316.486,
    y: 79.717,
    width: 30.432,
    height: 2.755,
    rx: 1.378,
    fill: "#fff"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 363.571,
    y: 79.717,
    width: 30.432,
    height: 2.755,
    rx: 1.378,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 216.706,
    y: 64.308,
    width: 42.236,
    height: 163.42,
    rx: 4,
    fill: "#487FB1",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.97 59.158c-.915 0-1.746-.22-2.492-.658a4.827 4.827 0 0 1-1.764-1.834c-.43-.775-.644-1.634-.644-2.576 0-.934.214-1.778.644-2.534a4.752 4.752 0 0 1 1.764-1.806 4.75 4.75 0 0 1 2.492-.672c.728 0 1.41.144 2.044.434.644.289 1.18.695 1.61 1.218.438.513.714 1.092.826 1.736h-1.498c-.168-.616-.532-1.116-1.092-1.498a3.177 3.177 0 0 0-1.89-.588c-.654 0-1.25.163-1.792.49a3.497 3.497 0 0 0-1.26 1.344 3.879 3.879 0 0 0-.462 1.876c0 .7.154 1.339.462 1.918.308.569.728 1.022 1.26 1.358.541.326 1.138.49 1.792.49.728 0 1.367-.206 1.918-.616.56-.411.92-.943 1.078-1.596h1.512c-.13.69-.41 1.302-.84 1.834s-.962.947-1.596 1.246a4.936 4.936 0 0 1-2.072.434zm9.167-7.112c.653 0 1.246.158 1.778.476.541.308.966.737 1.274 1.288.317.541.476 1.143.476 1.806 0 .653-.159 1.25-.476 1.792-.308.541-.733.97-1.274 1.288a3.484 3.484 0 0 1-1.778.462 3.56 3.56 0 0 1-1.792-.462 3.55 3.55 0 0 1-1.288-1.288 3.56 3.56 0 0 1-.462-1.792c0-.663.154-1.265.462-1.806.317-.551.742-.98 1.274-1.288a3.505 3.505 0 0 1 1.806-.476zm-2.296 3.57c0 .429.103.821.308 1.176a2.279 2.279 0 0 0 1.988 1.134c.41 0 .793-.103 1.148-.308a2.3 2.3 0 0 0 .84-.826c.205-.355.308-.747.308-1.176 0-.43-.103-.822-.308-1.176a2.237 2.237 0 0 0-.84-.854 2.253 2.253 0 0 0-1.148-.308c-.42 0-.808.102-1.162.308a2.27 2.27 0 0 0-.826.854 2.305 2.305 0 0 0-.308 1.176zm8.54-2.198a2.404 2.404 0 0 1 2.212-1.372c.878 0 1.573.275 2.087.826.513.55.77 1.297.77 2.24v3.906h-1.302v-3.766c0-.598-.168-1.074-.504-1.428-.336-.364-.784-.546-1.344-.546-.57 0-1.032.182-1.386.546-.346.354-.518.83-.518 1.428h-.014v3.766h-1.288v-6.832h1.288v1.232zm9.53 5.684c-.738 0-1.322-.215-1.75-.644-.43-.43-.645-1.05-.645-1.862v-3.178h-1.33v-1.232h1.33v-1.848h1.288v1.848h1.848v1.232h-1.848v3.15c0 .457.121.793.364 1.008.243.205.579.308 1.008.308.196 0 .355-.019.476-.056v1.19a2.85 2.85 0 0 1-.742.084zm4.801.056a3.485 3.485 0 0 1-1.778-.462 3.445 3.445 0 0 1-1.26-1.302 3.665 3.665 0 0 1-.462-1.82c0-.644.154-1.232.462-1.764a3.37 3.37 0 0 1 1.26-1.274 3.38 3.38 0 0 1 1.764-.476c.607 0 1.157.144 1.652.434.504.289.901.686 1.19 1.19.299.504.448 1.068.448 1.694l-.014.504h-5.53c.056.644.289 1.166.7 1.568.411.392.938.588 1.582.588.485 0 .905-.112 1.26-.336.355-.224.574-.518.658-.882h1.274c-.121.709-.481 1.278-1.078 1.708-.588.42-1.297.63-2.128.63zm1.904-4.27a1.83 1.83 0 0 0-.616-1.232c-.364-.327-.812-.49-1.344-.49-.551 0-1.017.154-1.4.462-.383.298-.635.718-.756 1.26h4.116zm4.096-1.47a2.402 2.402 0 0 1 2.212-1.372c.877 0 1.572.275 2.086.826.513.55.77 1.297.77 2.24v3.906h-1.302v-3.766c0-.598-.168-1.074-.504-1.428-.336-.364-.784-.546-1.344-.546-.57 0-1.032.182-1.386.546-.346.354-.518.83-.518 1.428h-.014v3.766h-1.288v-6.832h1.288v1.232zm9.528 5.684c-.737 0-1.32-.215-1.75-.644-.429-.43-.644-1.05-.644-1.862v-3.178h-1.33v-1.232h1.33v-1.848h1.288v1.848h1.848v1.232h-1.848v3.15c0 .457.122.793.364 1.008.243.205.579.308 1.008.308.196 0 .355-.019.476-.056v1.19a2.845 2.845 0 0 1-.742.084zm11.029-9.884v1.288h-4.27v2.688h3.808v1.288h-3.808v3.248h4.27v1.288h-5.628v-9.8h5.628zm2.344 2.282c0-.812.215-1.433.644-1.862.43-.43 1.013-.644 1.75-.644.28 0 .532.028.756.084v1.19a1.912 1.912 0 0 0-.49-.056c-.914 0-1.372.434-1.372 1.302v.672h1.862v1.232h-1.862v5.6h-1.288v-5.6h-1.33v-1.232h1.33V51.5zm5.073 0c0-.812.214-1.433.644-1.862.429-.43 1.012-.644 1.75-.644.28 0 .532.028.756.084v1.19a1.918 1.918 0 0 0-.49-.056c-.915 0-1.372.434-1.372 1.302v.672h1.862v1.232h-1.862v5.6h-1.288v-5.6h-1.33v-1.232h1.33V51.5zm6.878 7.658a3.482 3.482 0 0 1-1.778-.462 3.445 3.445 0 0 1-1.26-1.302 3.665 3.665 0 0 1-.462-1.82c0-.644.154-1.232.462-1.764a3.37 3.37 0 0 1 1.26-1.274 3.38 3.38 0 0 1 1.764-.476c.606 0 1.157.144 1.652.434.504.289.9.686 1.19 1.19.298.504.448 1.068.448 1.694l-.014.504h-5.53c.056.644.289 1.166.7 1.568.41.392.938.588 1.582.588.485 0 .905-.112 1.26-.336.354-.224.574-.518.658-.882h1.274a2.57 2.57 0 0 1-1.078 1.708c-.588.42-1.298.63-2.128.63zm1.904-4.27a1.83 1.83 0 0 0-.616-1.232c-.364-.327-.812-.49-1.344-.49-.551 0-1.018.154-1.4.462-.383.298-.635.718-.756 1.26h4.116zm5.807 4.27a3.56 3.56 0 0 1-1.792-.462 3.583 3.583 0 0 1-1.274-1.288 3.56 3.56 0 0 1-.462-1.792c0-.663.154-1.265.462-1.806.317-.551.742-.98 1.274-1.288a3.479 3.479 0 0 1 1.792-.476c.523 0 1.017.107 1.484.322.467.214.849.513 1.148.896.308.382.499.807.574 1.274h-1.316c-.093-.364-.322-.663-.686-.896a2.083 2.083 0 0 0-1.204-.364c-.42 0-.803.102-1.148.308a2.3 2.3 0 0 0-.826.84 2.419 2.419 0 0 0-.294 1.19c0 .429.098.821.294 1.176.205.345.481.62.826.826.345.205.728.308 1.148.308.457 0 .863-.122 1.218-.364.364-.252.593-.57.686-.952h1.302a2.67 2.67 0 0 1-.56 1.316 3.17 3.17 0 0 1-1.148.91 3.542 3.542 0 0 1-1.498.322zm7.639-.056c-.737 0-1.321-.215-1.75-.644-.429-.43-.644-1.05-.644-1.862v-3.178h-1.33v-1.232h1.33v-1.848h1.288v1.848h1.848v1.232h-1.848v3.15c0 .457.121.793.364 1.008.243.205.579.308 1.008.308.196 0 .355-.019.476-.056v1.19a2.85 2.85 0 0 1-.742.084zm3.378-6.916v6.832h-1.302v-6.832h1.302zm-.644-1.33a.869.869 0 0 1-.616-.252.869.869 0 0 1-.252-.616c0-.234.084-.434.252-.602a.846.846 0 0 1 .616-.266c.233 0 .434.088.602.266a.802.802 0 0 1 .266.602.869.869 0 0 1-.252.616.837.837 0 0 1-.616.252zm5.75 8.162h-1.12l-2.884-6.832h1.4l2.044 5.152 2.03-5.152h1.414l-2.884 6.832zm6.832.14a3.482 3.482 0 0 1-1.778-.462 3.445 3.445 0 0 1-1.26-1.302 3.665 3.665 0 0 1-.462-1.82c0-.644.154-1.232.462-1.764a3.37 3.37 0 0 1 1.26-1.274 3.38 3.38 0 0 1 1.764-.476c.606 0 1.157.144 1.652.434.504.289.9.686 1.19 1.19.298.504.448 1.068.448 1.694l-.014.504h-5.53c.056.644.289 1.166.7 1.568.41.392.938.588 1.582.588.485 0 .905-.112 1.26-.336.354-.224.574-.518.658-.882h1.274a2.57 2.57 0 0 1-1.078 1.708c-.588.42-1.298.63-2.128.63zm1.904-4.27a1.83 1.83 0 0 0-.616-1.232c-.364-.327-.812-.49-1.344-.49-.551 0-1.018.154-1.4.462-.383.298-.635.718-.756 1.26h4.116zm4.095-1.47c.215-.439.514-.775.896-1.008a2.407 2.407 0 0 1 1.316-.364c.878 0 1.573.275 2.086.826.514.55.77 1.297.77 2.24v3.906h-1.302v-3.766c0-.598-.168-1.074-.504-1.428-.336-.364-.784-.546-1.344-.546-.569 0-1.031.182-1.386.546-.345.354-.518.83-.518 1.428h-.014v3.766h-1.288v-6.832h1.288v1.232zm9.997 5.74a3.482 3.482 0 0 1-1.778-.462 3.445 3.445 0 0 1-1.26-1.302 3.665 3.665 0 0 1-.462-1.82c0-.644.154-1.232.462-1.764a3.37 3.37 0 0 1 1.26-1.274 3.38 3.38 0 0 1 1.764-.476c.606 0 1.157.144 1.652.434.504.289.9.686 1.19 1.19.298.504.448 1.068.448 1.694l-.014.504h-5.53c.056.644.289 1.166.7 1.568.41.392.938.588 1.582.588.485 0 .905-.112 1.26-.336.354-.224.574-.518.658-.882h1.274a2.57 2.57 0 0 1-1.078 1.708c-.588.42-1.298.63-2.128.63zm1.904-4.27a1.83 1.83 0 0 0-.616-1.232c-.364-.327-.812-.49-1.344-.49-.551 0-1.018.154-1.4.462-.383.298-.635.718-.756 1.26h4.116zm5.201 4.27c-.802 0-1.465-.201-1.988-.602-.522-.402-.816-.948-.882-1.638h1.232c.047.336.215.606.504.812.29.205.649.308 1.078.308.42 0 .756-.089 1.008-.266.262-.178.392-.411.392-.7 0-.336-.14-.574-.42-.714-.28-.14-.709-.266-1.288-.378a9.552 9.552 0 0 1-1.232-.322 1.943 1.943 0 0 1-.798-.546c-.214-.252-.322-.602-.322-1.05 0-.588.229-1.069.686-1.442.458-.383 1.064-.574 1.82-.574.7 0 1.302.186 1.806.56.514.364.812.863.896 1.498h-1.302c-.046-.28-.2-.509-.462-.686-.261-.187-.583-.28-.966-.28-.364 0-.658.074-.882.224-.224.149-.336.35-.336.602 0 .214.07.387.21.518.14.13.313.228.518.294.206.056.5.121.882.196.514.093.934.2 1.26.322.327.112.607.308.84.588.234.28.35.667.35 1.162 0 .401-.116.765-.35 1.092-.224.317-.536.569-.938.756-.392.177-.83.266-1.316.266zm6.358 0c-.803 0-1.466-.201-1.988-.602-.523-.402-.817-.948-.882-1.638h1.232c.046.336.214.606.504.812.289.205.648.308 1.078.308.42 0 .756-.089 1.008-.266.261-.178.392-.411.392-.7 0-.336-.14-.574-.42-.714-.28-.14-.71-.266-1.288-.378a9.508 9.508 0 0 1-1.232-.322 1.943 1.943 0 0 1-.798-.546c-.215-.252-.322-.602-.322-1.05 0-.588.228-1.069.686-1.442.457-.383 1.064-.574 1.82-.574.7 0 1.302.186 1.806.56.513.364.812.863.896 1.498h-1.302c-.047-.28-.201-.509-.462-.686-.262-.187-.584-.28-.966-.28-.364 0-.658.074-.882.224-.224.149-.336.35-.336.602 0 .214.07.387.21.518.14.13.312.228.518.294.205.056.499.121.882.196.513.093.933.2 1.26.322.326.112.606.308.84.588.233.28.35.667.35 1.162 0 .401-.117.765-.35 1.092-.224.317-.537.569-.938.756a3.16 3.16 0 0 1-1.316.266z",
    fill: "#8C8C8C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "pj7ydgepma",
    x: 0.934,
    y: 0.462,
    width: 483.508,
    height: 282.42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_501_1500"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_501_1500",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentEffectivenessIllustration);
export default __webpack_public_path__ + "static/media/content-effectiveness-illustration.4a54054eed6e9872a650222b450a446d.svg";
export { ForwardRef as ReactComponent };